<template>
  <!-- <CChartLine :datasets="defaultDatasets" :options="defaultOptions" /> -->
  <div id="chart">
    <Apexchart
      type="area"
      height="350"
      :options="defaultOptions"
      :series="defaultDatasets"
    ></Apexchart>
  </div>
</template>

<script>
import firebase from "firebase";
const db = firebase.firestore();
import { CChartLine } from "@coreui/vue-chartjs";
import { getStyle, hexToRgba } from "@coreui/utils/src";
import Apexchart from "vue-apexcharts";

function random(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

export default {
  name: "MainChartExample",
  components: {
    CChartLine,
    Apexchart,
  },
  data() {
    return {
      tokenList: "",
      grapdiv: [],
      allgraph: [],
      graph: [],
      options: [],
      tableData: [],
      tableData1: [],
      tokenBal: [],
      grapdata: "",
      tableToken: [],
      tokenLength: "",
      totalToken: "",
      total: 0,
      randomColor: "",
      tooltips: [],
    };
  },
    mounted() {
      // this.$root.$on("allgrapdata", (value) => {
      //   console.log("received", value);
      //   this.tokenList = value;
      // });
    },
  computed: {
    defaultDatasets() {
      const brandSuccess = getStyle("success") || "#4dbd74";
      const brandInfo = getStyle("info") || "#20a8d8";
      const brandDanger = getStyle("danger") || "#f86c6b";

      let elements = 3;
      const data1 = [];
      const data2 = [];
      const data3 = [];
      let tdata = [];
      // console.log("this.tokenList",this.tokenList)
      
      for (let i in this.tokenList) {
        //  console.log("entered",this.tokenList[i].length);
        let name = [];
        let count = [];
        for (let j = 0; j < this.tokenList[i].length; j++) {
          if (this.tokenList[i][j].name && this.tokenList[i][j].count) {
            name.push(this.tokenList[i][j].name);
            count.push(
              this.tokenList[i][j].count + "$" + this.tokenList[i][j].name
            );
          }
        }
        this.tooltips.push(name);
        tdata.push({
          name: i,
          labels: name,
          backgroundColor: hexToRgba(brandInfo, 10),
          borderColor: brandInfo,
          pointHoverBackgroundColor: brandInfo,
          borderWidth: 2,
          data: count,
        });
      }
      // console.log("final computed", tdata);
      return tdata;
    },
    defaultOptions() {
      return {
        chart: {
          height: 350,
          type: "area",
        },
        // dataLabels: {
        //   enabled: true,
        //   enabledOnSeries: true,
        //   formatter: function (val, opts) {
        //     return "123456789";
        //   },
        // },
        tooltip: {
          custom: function ({ series, seriesIndex, dataPointIndex, w }) {
            let mail = w.config.series[seriesIndex].data[dataPointIndex].split(
              "$"
            );
            return (
              '<div class="arrow_box">' +
              "<span>" +
              mail[1] +
              "</span>" +
              "</div>"
            );
          },
        },
        stroke: {
          curve: "smooth",
        },
      };
    },
  },
  methods: {
   
  

    getallgraphdata() {
     
       console.log("entered function")
      let token = [];
     
      db.collection("collectedCoins2")
      .limit(30)
        .get()
        .then((snapshot) => {
          for (let doc of snapshot.docs) {
            for (let usertoken in doc.data()) {
              if (doc.data()[usertoken].length > 0) {
                if (token[usertoken]) {
                  token[usertoken].push({
                    name: doc.id,
                    count: doc.data()[usertoken].length,
                  });
                } else {
                  token[usertoken] = [];
                  token[usertoken].push({
                    name: doc.id,
                    count: doc.data()[usertoken].length,
                  });
                }
              }
            }
          }
          this.tokenList = token;
          console.log("token", token);
        });
    },
    onChange() {
      this.total = "";
      db.collection("collectedCoins")
        .where(this.grapdata, "!=", null)
        .get()
        .then((snapshot) => {
          for (let doc of snapshot.docs) {
            if (doc.data()[this.grapdata].length == 0) {
              this.tableData.push(doc.data()[this.grapdata].length);
              this.tokenBal = [];
            } else {
              this.tokenBal.push(doc.data()[this.grapdata].length);
              // this.total += this.tokenBal.this.grapdata.length;
            }
          }
        });
    },
  },
  created() {
    this.getallgraphdata()
    // console.log("entered all chart")
    
    //  console.log("randomColor",this.tokenList)
    // this.getallgraphdata();
    //     this.randomColor = Math.floor(Math.random()*16777215).toString(16),
    //   console.log("randomColor",this.randomColor)
    //       const randomColor = Math.floor(Math.random()*16777215).toString(16);
    //   "#" + randomColor;
  },
};
</script>
